module.exports = __webpack_public_path__ + "media/src/images/site-top/image2-59c84b14fe289b49faf527376061e003.jpg";